import * as actionTypes from '../actions/actionTypes'
import { updateObject } from '../../utils/utility'

const initialState = {
    ingredients: null,
    totalPrice: 0,
    error: false,
    building: false,
}

const INGREDIENT_PRICES = {
    'salad': 18,
    'paneer-tikka': 30,
    'cheese': 15,
    'patty': 22
}

const addIngredient = (state, action) => {
    const updatedIngredient = { [action.ingredientName]: state.ingredients[action.ingredientName] + 1 }
    const updatedIngredients = updateObject(state.ingredients, updatedIngredient)
    const updatedState = {
        ingredients: updatedIngredients,
        totalPrice: state.totalPrice + INGREDIENT_PRICES[action.ingredientName],
        building: true,
    }
    return updateObject(state, updatedState)
}

const removeIngredient = (state, action) => {
    const updatedIng = { [action.ingredientName]: state.ingredients[action.ingredientName] - 1 }
    const updatedIngs = updateObject(state.ingredients, updatedIng)
    return updateObject(state, {
        ingredients: updatedIngs,
        totalPrice: state.totalPrice - INGREDIENT_PRICES[action.ingredientName],
        building: true,
    })
}

const setIngredients = (state, action) => {
    return updateObject(state, {
        ingredients: { ...action.ingredients },
        error: false,
        totalPrice: 0,
        building: false,
    })
}

const fetchIngredientsFailed = (state, action) => {
    return updateObject(state, { error: true, })
}


const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.ADD_INGREDIENT: return addIngredient(state, action)
        case actionTypes.REMOVE_INGREDIENT: return removeIngredient(state, action)
        case actionTypes.SET_INGREDIENTS: return setIngredients(state, action)
        case actionTypes.FETCH_INGREDIENTS_FAILED: return fetchIngredientsFailed(state, action)
        default: return state
    }
}

export default reducer


// WEBPACK FOOTER //
// ./src/store/reducers/burgerBuilder.js